import { motion } from "framer-motion";

export default function HeroSection() {
  return (
    <section className="relative flex flex-col items-center justify-center px-6 overflow-hidden mt-0 pb-2">
      {/* Subtle radial gradient overlay */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_rgba(255,255,255,0.02)_0%,_transparent_70%)]" />

      <motion.div
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1.2, ease: [0.16, 1, 0.3, 1] }}
        className="relative z-10 text-center max-w-5xl"
      >
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3, duration: 1 }}
          className="text-muted-foreground text-sm tracking-[0.3em] uppercase mb-8 font-light mt-5"
        >
          Experiencia · Diseño · Excelencia
        </motion.p>

        <h1 className="text-5xl sm:text-7xl md:text-8xl lg:text-8xl font-black uppercase tracking-[-0.04em] leading-[0.85] text-foreground">
          Los Tres
          <br />
          <span className="text-muted-foreground">Pilares que transforman tu Negocio</span>
        </h1>

        <motion.div
          initial={{ scaleX: 0 }}
          animate={{ scaleX: 1 }}
          transition={{ delay: 0.8, duration: 1, ease: [0.16, 1, 0.3, 1] }}
          className="w-16 h-px bg-muted-foreground/40 mx-auto mt-10 mb-8 origin-left"
        />



        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1, duration: 1 }}
          className="text-muted-foreground text-base md:text-lg font-light max-w-lg mx-auto leading-relaxed"
        >
          Donde la visión deja de ser una idea y se convierte en resultados reales.
          Nuestro sistema combina compromiso, innovación y precisión para simplificar tu trabajo, optimizar tu tiempo y ayudarte a crecer sin límites.
        </motion.p>
      </motion.div>

      {/* Scroll indicator */}

      {/* <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.5, duration: 1 }}
        className="absolute bottom-12 left-1/2 -translate-x-1/2 flex flex-col items-center gap-3 py-5"
      >
        <span className="text-muted-foreground/40 text-[10px] tracking-[0.4em] uppercase">
          Scroll
        </span>
        <motion.div
          animate={{ y: [0, 8, 0] }}
          transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
          className="w-px h-8 bg-gradient-to-b from-muted-foreground/40 to-transparent"
        />
      </motion.div> */}

    </section>
  );
}